// A default, general template for users who haven't set custom requirements.
export const defaultCpdRequirement = {
  name: "Standard Annual 50 Hours",
  cycleYears: 1,
  totalHours: 50,
  infoUrl: "https://www.medicalradiationpracticeboard.gov.au/Registration-Standards/FAQ/Registration-standards.aspx",
  // No specific groups for the default, but the structure is here
  categoryGroups: [] 
};

// AHPRA – Medical Radiation Practitioners (Australia)
export const ahpraCpdTemplate = {
  name: "AHPRA (MRPBA)",
  cycleYears: 3,
  totalHours: 60,
  minAnnualHours: 10,
  infoUrl: "https://www.medicalradiationpracticeboard.gov.au/Registration-Standards/Continuing-professional-development.aspx",
  notes: "Requires a total of 60 hours over a 3-year cycle.",
  // Defines how to group your app's categories into AHPRA's requirements
  categoryGroups: [
    {
      groupName: "Substantive CPD",
      requiredHours: 35, // Over 3 years
      mapsFrom: [
        "Educational Activities",
        "Reviewing & Reflecting on Practice",
        "Measuring Outcomes & Quality Improvement",
        "Teaching, Training & Supervising",
        "Research & Scholarship",
        "Technology & Innovation"
      ]
    },
    {
      groupName: "General CPD",
      mapsFrom: [
        "Self-Directed Learning",
        "Professional Development & Skills",
        "Wellbeing & Resilience",
        "Other / Unclassified"
      ]
    }
  ]
};

// RANZCR – Radiation Oncologists & Clinical Radiologists (Australia & NZ)
export const ranzcrCpdTemplate = {
  name: "RANZCR",
  cycleYears: 1,
  totalHours: 50,
  infoUrl: "https://www.ranzcr.com/fellows/general/cpd-overview",
  notes: "Requires activities across three specific domains.",
  categoryGroups: [
    {
      groupName: "Educational Activities",
      requiredHours: 12.5,
      mapsFrom: ["Educational Activities", "Self-Directed Learning", "Reading & Research", "Technology & Innovation"]
    },
    {
      groupName: "Reviewing Performance & Reflecting",
      requiredHours: 12.5,
      mapsFrom: ["Reviewing & Reflecting on Practice"]
    },
    {
      groupName: "Measuring Outcomes",
      requiredHours: 12.5,
      mapsFrom: ["Measuring Outcomes & Quality Improvement", "Teaching, Training & Supervising", "Research & Scholarship"]
    }
  ]
};

// ARRT – American Registry of Radiologic Technologists (U.S.)
export const arrtCpdTemplate = {
  name: "ARRT (U.S.)",
  cycleYears: 2, // Biennium
  totalHours: 24, // 24 credits, 1 credit = 1 hour
  infoUrl: "https://www.arrt.org/pages/resources/maintaining-credentials/continuing-education",
  notes: "Must be ARRT-approved Category A or A+ credits.",
  categoryGroups: []
};

// RCR – Royal College of Radiologists (UK)
export const rcrCpdTemplate = {
  name: "RCR (UK)",
  cycleYears: 5,
  totalHours: 250, // 250 credits, ~1 credit per hour
  minAnnualHours: 25,
  infoUrl: "https://www.rcr.ac.uk/cpd-and-events/cpd-scheme/",
  notes: "A flexible, credits-based system. A minimum of 50 credits per year is recommended.",
  categoryGroups: []
};

// CAMRT – Canadian Association of Medical Radiation Technologists
export const camrtCpdTemplate = {
  name: "CAMRT (Canada)",
  cycleYears: 3,
  totalHours: 36,
  minAnnualHours: 6,
  infoUrl: "https://camrt-bpg.ca/professionalism/professional-development/cpd/",
  notes: "Encourages a mix of formal and informal learning activities.",
  categoryGroups: []
};

// Faculty of Radiologists, RCPI (Ireland)
export const frcrCpdTemplate = {
  name: "RCPI Faculty of Radiologists (Ireland)",
  cycleYears: 1,
  totalHours: 50, // 50 credits, 1 credit per hour
  minAnnualHours: 40,
  infoUrl: "https://www.rcpi.ie/Learn-and-Develop/Lifelong-Learning/Professional-Competence/Professional-Competence-Guidelines-and-Resources/CPD-Explained",
  notes: "Requires a minimum of 20 external (accredited) credits per year.",
  categoryGroups: []
};

// GMC – General Medical Council (UK)
export const gmcCpdTemplate = {
  name: "GMC (UK)",
  cycleYears: 1,
  totalHours: 0, // No fixed hours
  infoUrl: "https://www.gmc-uk.org/registration-and-licensing/managing-your-registration/revalidation/guidance-on-supporting-information-for-revalidation",
  notes: "No fixed hours required. Focus is on reflective practice aligned with your scope of work for annual appraisal and revalidation.",
  categoryGroups: []
};